// ** Dropdowns Imports
import IntlDropdown from "./IntlDropdown";
// import CartDropdown from './CartDropdown'
import UserDropdown from "./UserDropdown";
import UserLogin from "./UserLogin";
// import NavbarSearch from './NavbarSearch'
import NotificationDropdown from "./NotificationDropdown";
import Navbar from "../../../../containers/Navbar";
// ** Third Party Components
import { Sun, Moon } from "react-feather";

import { isUserLoggedIn } from "@utils";
import { Fragment, useEffect, useState } from "react";
// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap";

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props;

  const [userMenu, setUserMenu] = useState(false);

  useEffect(() => {
    setUserMenu(setUserMenu());
  });

  return (
    <div className=" ms-auto w-100 justify-content-around ">
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        <Navbar />
      </div>
    </div>
  );
};
export default NavbarUser;
